export const translations = {
  es: {
    //GENERAL
    lang: `ES`,
    disponible: `Saldo disponible`,
    contacto: `Contacto`,
    copyright:`© MSInvs 2022`,
    offline1:`Vaya, parece que estás sin conexión...`,
    offline2:`Probar de nuevo`,

    //INICIO SESIÓN
        //ERRORES
        introduceContra:`Introduce una contraseña \n \n`,
        introduceCorreo:`Introduce un correo \n \n`,
        contraIncorrecta:`Contraseña incorrecta \n \n`,
        noExisteCorreo:`No existe ninguna cuenta con esa dirección de correo \n \n`,
    deAcuerdo: `De acuerdo`,
    correoElectronico:`Correo electrónico`,
    contra:`Contraseña`,
    contraActual:`Contraseña actual`,
    contraOlvidada:`He olvidado mi contraseña`,
    iniciarSesion:`Iniciar sesión`,
    noTienesCuenta:`¿No tienes cuenta aún?`,
    registrate: `Regístrate`,

    //REGISTRO
    codigoReferido:`Código de referido`,
    codigoRefTexto:`¿Tienes un código de referido? Introdúcelo en la caja de abajo.`,
    codigoRefTexto2:`¿No lo tienes? ¡No pasa nada! Puedes continuar con el registro.`,

    yaExisteCorreo:`Ya existe una cuenta con este correo electrónico \n \n`,
    correoNoValido:`El correo introducido no es válido \n \n`,
    datosPersonales: `Datos personales`,
    nombre:`Nombre`,
    apellidos:`Apellidos`,
    telefono:`Teléfono`,
    bienvenido:`¡Bienvenid@,`,
    iniciaParaConfirmar:`Inicia sesión para confirmar que tus credenciales son correctas`,
    identificacion:`Identificación`,
    dni:`DNI/NIE/NIF`,
    domicilio:`Domicilio (Calle, Número)`,
    poblacion:`Código postal`,
    heLeido:`He leído y acepto los términos y condiciones establecidos`,


    //CONTRASEÑA OLVIDADA
    codigoIncorrecto:`El código introducido no es válido, comprueba que lo has introducido correctamente \n \n`,
    contraseOlvidada: `Contraseña olvidada`,
    pulsaParaRecibir: `Pulsa aquí para recibir el código en tu correo`,
    codigo:`Código`,
    siguiente: `Siguiente`,
    cambioCorrecto:`Cambio de contraseña correcto.`,
    nuevaContra:`Nueva contraseña`,

    repetirContra:`Repetir contraseña`,
    contraNoValida: `La contraseña introducida no es válida. Se requieren un mínimo de 8 caracteres para que sea segura \n \n`,
    contrasNoCoinciden: `Las contraseñas no coinciden \n \n`,

    //SNACKBAR
    portapapeles: `Copiado al portapapeles`,
    operacionExito: `Operación realizada con éxito`,
    correoEnviado: `Correo enviado`,
    proximaActualizacion:`Disponible próximamente`,

    //ITEM
    dias: `días`,
    fin: `FIN`,
    diasRestantes: `Dias restantes`,
    beneficio: `Beneficio`,
    completado: `Completado`,
    rentabilidadInicial:`Rentabilidad inicial`,
    rentabilidadFinal:`Rentabilidad final`,
    devolucion:`Suma`,
    vayaCubiertas:`¡Vaya!\n\nParece que todas nuestras inversiones están cubiertas...`,
    vayaProximas:`¡Vaya!\n\nAhora mismo no hay nada que votar, pero no te preocupes, hay más inversiones de camino.`,
    vayaSinInv:`¡Vaya!\n\nParece que no tienes ninguna inversión activa...\n\nO puede que donde invertiste ya haya completado el total necesario, si es así, ¡felicidades! `,
    vayaSinInvComp:`¡Vaya!\n\nAquí no hay nada...\n\nPuede que donde invertiste aún no haya completado el total necesario. `,
    vayaSinInvDev:`¡Vaya!\n\nAquí no hay nada aún...\n\nSi ya has realizado tu primera inversión, sólo queda esperar a que sea cerrada.\n\nSi aún no lo has hecho, ¡te estamos esperando!`,

    //AYUDA INICIAL
    desliza: `Continúa leyendo para aceptar`,
    entendido: `Entendido`,
    help1: `Bienvenido a MSInvs`,
    help2: `Estos son algunos conceptos básicos que necesitas entender antes de comenzar a invertir:`,
    help3: `Saldo disponible`,
    help4: `Es aquel del que dispones para invertir. Aparece claramente en la parte inferior izquierda de la pantalla.`,
    help5: `Saldo contable`,
    help6: `El que has de transferir antes del plazo idicado para que pase a ser "Saldo Disponible". La información necesaria aparece claramente desglosada en la parte superior de la pantalla de inicio.`,
    help7: `Navegación`,
    help8: `En la barra de navegación encontrarás los botones de acceso a las diferentes pantallas de la aplicación, así como tu saldo disponible y un botón de contacto que te llevará a un formulario.`,
    help9: `Inicio`,
    help10: `En la pantalla de inicio aparecen listadas todas las inversiones según el estado en el que se encuentren (disponibles, cubiertas, cerradas, en valoración).`,
    help11: `Puedes tocar en ellas para acceder a sus datos.`,
    help12: `Inversiones disponibles`,
    help13: `Al tocar en alguna inversión, entrarás a su página individual. En ella aparecen listadas todas sus características, una descripción y una galería de imágenes.`,
    help14: `Si es posible invertir, aparecerá un botón que abrirá un cuadro de diálogo que te permitirá insertar la cantidad de dinero que quieras invertir.`,
    help15: `Si dispones del saldo que vas a invertir, no tendrás que hacer nada más. En cambio, si el dinero que quieres invertir es mayor al que dispones en tu cuenta, tendrás que realizar una transferencia de la diferencia.`,
    help16: `Inversiones en valoración`,
    help17: `La interfaz es la misma que las inversiones disponibles, sólamente cambia el botón de "Invertir" por uno de "Me gusta" y uno de "No me gusta", junto a sus contadores de votos. Por supuesto, votar es totalmente gratis.`,
    help18: `Gracias a esta información, desde MSInvs podremos traer un mayor número de inversiones que resulten interesantes a los usuarios.`,
    help19: `Añadir fondos`,
    help20: `Esta pantalla es la encargada de solicitar fondos. En ella tendrás que rellenar el campo de texto con el dinero que te gustaría tener como saldo disponible, es decir, listo para invertir.`,
    help21: `Mis inversiones`,
    help22: `Aquí aparecen listadas todas las propiedades en las que has participado (cuyo dinero aún no te ha sido devuelto), así como la inversión que realizaste en cada una de ellas.`,
    help23: `Perfil`,
    help24: `En la pantalla de perfil aparecen listadas una serie de funcionalidades que siempre viene bien tener a mano.`,
    help25: `El apartado "Inversiones pasadas" recoge las inversiones en las que has participado y de las que se te ha devuelto el dinero, para que tengas un histórico claro.`,
    help252: `El apartado "Invitar a un amigo" te proporcionará tu código de referido. Por cada amigo que se registre y realice su primera inversión, podrás recibir hasta 50€ de beneficio en tu saldo disponible.`,
    help26: `El botón de "Eliminar cuenta" se encargará de borrar toda tu información de las bases de datos de MSInvs. Si quisieras volver a invertir, tendrías que volver a registrarte y perderías el acceso a todos tus datos anteriores.`,
    help27: `Gracias`,
    help28: `Desde el equipo de MSInvs esperamos haber resuelto tus dudas con esta información. Si aun así te gustaría preguntar algo, no dudes en ponerte en contacto con nosotros.`,
    help29: `Muchas gracias por confiar en nosotros.`,

    //INICIO
    inicio: `Inicio`,
    contable1: `Recuerda que tienes que ingresar`,
    contable2: `antes del día indicado o tus operaciones serán revertidas:`,
    contableAntes: `Antes del `,
    contableIngreso: `Ingreso de saldo`,

    //SECCIONES
    novedades: `Novedades`,
    disponibles: `Inversiones disponibles`,
    verMas: `Ver más`,
    cubiertas: `Inversiones cubiertas`,
    cerradas: `Inversiones cerradas`,
    proximas: `Próximamente`,

    //BUSCAR
    buscar: `Buscar`,
    corto: `Corto`,
    medio: `Medio`,
    largo: `Largo`,
    enCurso: `En curso`,
    completas:`Completas`,

    //AÑADIR FONDOS
    addFondos: `Añadir fondos`,
    copiarIBAN: `Copiar IBAN`,

    //MIS INVERSIONES
    misInvs: `Mis inversiones`,
    hasInvertido: `Has invertido:`,
    seDevolvera: `Se te devolverá:`,

    //PERFIL
    perfil: `Perfil`,
    privacidad: `Política de privacidad`,
    tos: `Términos de servicio`,
    comoFunciona: `Cómo funciona`,
    inversionesPasadas: `Mis inversiones pasadas`,
    invitarAmigos: `Invitar a un amigo`,
    notificaciones: `Ajustes de notificaciones`,
    cambiarContra: `Cambiar contraseña`,
    borrarCuenta: `Borrar mi cuenta`,

    //REFERIDOS
    textRef1:`Tu código de referido es`,

    textRef2:`Por cada amigo que se registre, cuando haga su primera operación podrás recibir hasta 50€ de bonificación en tu saldo disponible.`,

    //BORRAR
    seguro: `¿Estás seguro de querer borrar tu cuenta,`,
    irreversible: `Esta acción es irreversible y tendrás que darte de alta de nuevo si quieres volver a invertir.`,
    volverAtras: `No, volver atrás`,
    estoySeguro: `Sí, estoy seguro`,
    cerrarSesion: `Cerrar sesión`,

    //INDIVIDUAL
    invertir:`Invertir`,
    puedesInvertir:`Puedes invertir hasta`,

  },

  en: {
    //GENERAL
    lang: `EN`,
    disponible: `Available balance`,
    contacto: `Contact`,
    copyright:`© MSInvs 2022`,
    offline1:`Oops, it seems like you are offline...`,
    offline2:`Try again`,

    //INICIO SESIÓN
        //ERRORES
        introduceContra:`Write your password \n \n`,
        introduceCorreo:`Write your email \n \n`,
        contraIncorrecta:`Wrong password \n \n`,
        noExisteCorreo:`This email is not registered \n \n`,
    deAcuerdo: `Okay`,
    correoElectronico:`Email`,
    contra:`Password`,
    contraActual:`Current password`,
    contraOlvidada:`Password forgotten`,
    iniciarSesion:`Log in`,
    noTienesCuenta:`New user?`,
    registrate: `Register now`,

    //REGISTRO
    codigoReferido:`Referral code`,
    codigoRefTexto:`Do you want to use a referral code? Write it in the field below.`,
    codigoRefTexto2:`You don't have one? No problem! You can continue with the registration.`,

    yaExisteCorreo:`This email is already registered \n \n`,
    correoNoValido:`Email not valid \n \n`,
    datosPersonales: `Personal data`,
    nombre:`Name`,
    apellidos:`Last name`,
    telefono:`Phone number`,
    bienvenido:`Welcome,`,
    iniciaParaConfirmar:`Log in to confirm your credentials are correct`,
    identificacion:`Identification`,
    dni:`ID Card (DNI/NIE/NIF)`,
    domicilio:`Address (Street, Number)`,
    poblacion:`ZIP Code`,
    heLeido:`I have read and I accept the terms and conditions`,


    //CONTRASEÑA OLVIDADA
    codigoIncorrecto: `Wrong code. Please confirm you wrote it correctly \n \n`,
    contraseOlvidada: `Forgotten password`,
    pulsaParaRecibir: `Press here to get your code via email`,
    codigo:`Code`,
    siguiente: `Next`,
    cambioCorrecto:`Password changed successfully.`,
    nuevaContra:`New password`,

    repetirContra:`Password repeat`,
    contraNoValida: `Password not valid. It must contain 8 characters minimum \n \n`,
    contrasNoCoinciden: `Passwords don't match \n \n`,

    //SNACKBAR
    portapapeles: `Copied to clipboard`,
    operacionExito: `Succesfull operation`,
    correoEnviado: `Email sent`,
    proximaActualizacion:`Available soon`,

    //ITEM
    dias: `days`,
    fin: `END`,
    diasRestantes: `Days left`,
    beneficio: `Profit`,
    completado: `Completed`,
    rentabilidadInicial:`Starting profit`,
    rentabilidadFinal:`Final profit`,
    devolucion:`Sum`,
    vayaCubiertas:`Oops!\n\nIt seems like all the investments are already full...`,
    vayaProximas:`Oops!\n\nThere is nothing to vote at the moment, but don't worry, more investments are on the way.`,
    vayaSinInv:`Oops!\n\nYou don't have any ongoing investment...\n\nMaybe where you invested is now full. If so... Congratulations!`,
    vayaSinInvComp:`Oops!\n\nThere is nothing to show here...\n\nMaybe where you invested is not full yet...`,
    vayaSinInvDev:`Oops!\n\nThere is nothing here yet...\n\nIf you have already invested, you just need to wait for it to be closed.\n\nIf not, we are waiting for you!`,

    //AYUDA INICIAL
    desliza: `Continue reading to dismiss`,
    entendido: `Understood`,
    help1: `Welcome to MSInvs`,
    help2: `There are some basic concepts you need to understand before investing:`,
    help3: `Available balance`,
    help4: `It is the money in your wallet. It appears at the bottom left of your screen.`,
    help5: `Countable balance`,
    help6: `It is the money you need to transfer in time to make it available. Necessary information appears broken down in the Home section.`,
    help7: `Navigation`,
    help8: `In the navigation bar you will find buttons to access the different app screens, as well as your available balance and a contact button that will redirect you to a form.`,
    help9: `Home`,
    help10: `Here, every investment is listed depending on the state they are in (available, full, closed or coming up next)`,
    help11: `You can tap them to get more information.`,
    help12: `Available investments`,
    help13: `When you touch any investment, you will enter it's individual screen. Here, characteristics, a brief description and an image gallery are shown.`,
    help14: `If it is possible to invest, a button will be shown. When pressed, you will be able to write in the pop-up the amount you want to invest.`,
    help15: `If you own the money you are investing, there is nothing else you have to do. But if you want to invest more than what you have available, you will have to transfer the difference.`,
    help16: `Coming up next`,
    help17: `It is the same interface as available investments, but the only difference is the button that appears. The "Invest" button changes for one "Like" and "Dislike" button. Of course, it is totally free to vote.`,
    help18: `Thanks to this information, we will be able to bring more interesting investments.`,
    help19: `Add funds`,
    help20: `This screen is responsible for requesting funds. Here, you will have to fill the money you would like to have in your wallet as available balance.`,
    help21: `My investments`,
    help22: `Here, you can find the investments you have made and haven't been refunded yet, as well as the amount you invested in each one.`,
    help23: `Profile`,
    help24: `In the profile screen you will find a list of functionalities and settings you can adjust.`,
    help25: `Inside "Past investments" all your ended (and refunded) investments will be listed, so you have a clear history.`,
    help252: `When "Invite a friend" is pressed, your referral code will be shown. For each friend who registers using it and makes its first investment, you could get up to 50€ benefit in your available balance.`,
    help26: `The "Delete account" button will delete all your information from our database. If you ever wanted to invest again, you would need to register again, losing all your previous data.`,
    help27: `Thank you`,
    help28: `From MSInvs we hope to have answered the doubts you might have. If you still want to ask anything, please contact us.`,
    help29: `Thank you for trusting us.`,

    //INICIO
    inicio: `Home`,
    contable1: `Remember you have to transfer`,
    contable2: `before the date marked or your operatios will be reverted:`,
    contableAntes: `Before `,
    contableIngreso: `Funds request`,

    //SECCIONES
    novedades: `New investments`,
    disponibles: `Available investments`,
    verMas: `See more`,
    cubiertas: `Full investments`,
    cerradas: `Closed investments`,
    proximas: `Coming up next`,

    //BUSCAR
    buscar: `Search`,
    corto: `Short`,
    medio: `Medium`,
    largo: `Long`,
    enCurso: `Ongoing`,
    completas:`Full`,

    //AÑADIR FONDOS
    addFondos: `Add funds`,
    copiarIBAN: `Copy IBAN`,

    //MIS INVERSIONES
    misInvs: `My investments`,
    hasInvertido: `You invested:`,
    seDevolvera: `You will be given:`,

    //PERFIL
    perfil: `Profile`,
    privacidad: `Privacy policy`,
    tos: `Terms of Service`,
    comoFunciona: `How it works`,
    inversionesPasadas: `Past investments`,
    invitarAmigos: `Invite a friend`,
    notificaciones: `Notification settings`,
    cambiarContra: `Change password`,
    borrarCuenta: `Delete account`,

      //COMING SOON    
      textRef1:`Your referral code is`,

      textRef2:`For each new registered friend, once they make the first investment you will get up to 50€ bonus on your available balance.`,
  

    //BORRAR
    seguro: `Are you sure you want to delete your account,`,
    irreversible: `This action cannot be undone and you will have to register again if you want to invest.`,
    volverAtras: `No, go back`,
    estoySeguro: `Yes, I am sure`,
    cerrarSesion: `Log out`,

    //INDIVIDUAL
    invertir:`Invest`,
    puedesInvertir:`You can invest up to`,

  },
};